import { SET_ERROR } from "../types";
const setError = (state = [], action) => {
    if (action.type === SET_ERROR) {
        state = action.payload;
    };
    return state;
};

export default setError;